import { createAction } from 'typesafe-actions';
import { ViewsModels } from '../types';

export const setLikeForReview = createAction('reviews/LIKE_DISLIKE/setLike')<string>();
export const cancelLikeForReview = createAction('reviews/LIKE_DISLIKE/cancelLike')<string>();
export const setDislikeForReview = createAction('reviews/LIKE_DISLIKE/setDislike')<string>();
export const cancelDislikeForReview = createAction('reviews/LIKE_DISLIKE/cancelDislike')<string>();
export const changeLikeToDislikeForReview = createAction(
  'reviews/LIKE_DISLIKE/changeLikeToDislike',
)<string>();
export const changeDislikeToLikeForReview = createAction(
  'reviews/LIKE_DISLIKE/changeDislikeToLike',
)<string>();

export const restoreVoterId = createAction('reviews/LIKE_DISLIKE/restoreVoterId')();
export const setVoterId = createAction('reviews/LIKE_DISLIKE/setVoterId')<string | null>();

export const resetReviewsOpinionsRecords = createAction('reviews/LIKE_DISLIKE/reset')<
  ViewsModels.ReviewsOpinionRecords[]
>();
